import { Flex } from '@radix-ui/themes';

import { AiSummary } from '../campaigns/components/AiSummary.jsx';
import { ConversationTrends } from '../campaigns/components/ConversationTrends.jsx';
import { PeakUsageHours } from '../campaigns/components/PeakUsageHours.jsx';
import styles from './AiConversations.module.css';

const AiConversations = ({ startDate, endDate }) => {
  return (
    <Flex direction="column" gap="4">
      <AiSummary startDate={startDate} endDate={endDate} />
      <div className={styles.halfColumns}>
        <ConversationTrends startDate={startDate} endDate={endDate} />
        <PeakUsageHours startDate={startDate} endDate={endDate} />
      </div>
    </Flex>
  );
};

export default AiConversations;
